import { Button } from "@mui/material";
import dayjs from "dayjs";

let col18s = []
for(let i = 0; i < 17; i++){
  col18s.push({ 
    field: `Litr${i + 1}`,
    headerName: `ครั้งที่${i + 1}`,
    width: 70,
    printWidth: 0.45,
    printAlign: "center",
    printMaxLength: 7,
    renderCell: ({value}) => <Button>{value}</Button>
  })
}
export const columns = [
  {
    field: "No",
    headerName: "No.",
    width: 50,
    align: 'center',
    printWidth: 0.3,
    printAlign: "center"
  },
  {
    field: "LicNm",
    headerName: "ทะเบียนรถ",
    width: 100,
    printWidth: 0.6,
  },
  {
    field: "DrvNm",
    headerName: "พนักงานขับรถ",
    width: 180,
    printWidth: 1.6,
    printMaxLength: 255
  },
  {
    field: "FuelTmSt",
    headerName: "เริ่มรอบ",
    width: 100,
    type: "dateTime",
    valueFormatter: (params) => {
      return params.value ? dayjs(params.value).format("DD/MM/YYYY") : "-";
    },
  },
  {
    field: "FuelTmEn",
    headerName: "จบรอบ",
    width: 100,
    type: "dateTime",
    valueFormatter: (params) => {
      return params.value ? dayjs(params.value).format("DD/MM/YYYY") : "-";
    },
  },
  ...col18s,
  {
    field: "TotalLitr",
    headerName: "รวมลิตร",
    width: 100,
    printWidth: 0.6,
    printAlign: "right"
  },
  {
    field: "MileTukSt",
    headerName: "ไมล์เริ่มต้น",
    width: 100,
    printWidth: 0.6,
    printMaxLength: 9,
    printAlign: "right"
  },
  {
    field: "MileTukEn",
    headerName: "ไมล์สิ้นสุด",
    width: 100,
    printWidth: 0.6,
    printMaxLength: 9,
    printAlign: "right"
  },
  {
    field: "MileTukDiff",
    headerName: "ระยะทาง",
    width: 100,
    printWidth: 0.6,
    printMaxLength: 9,
    printAlign: "right"
  },
  {
    field: "Rate",
    headerName: "Rate",
    width: 60,
    printWidth: 0.4,
    printAlign: "right"
  },
  {
    field: "NumJo",
    headerName: "งาน",
    width: 60,
    printWidth: 0.4,
    align: 'center',
    printAlign: "center"
  },
]